export const TrainProfile = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 21H25.2651C27.1015 21 28.6392 19.6084 28.8219 17.7811V17.7811C28.934 16.6601 28.511 15.5518 27.6805 14.7904L19.2939 7.10277C17.8185 5.75028 15.8897 5 13.8881 5H2" stroke="currentColor" stroke-width="2"/>
<path d="M23.5 11H14C13.4477 11 13 10.5523 13 10V5" stroke="currentColor" stroke-width="2"/>
<path d="M2 15H8C8.55228 15 9 14.5523 9 14V12C9 11.4477 8.55228 11 8 11H2" stroke="currentColor" stroke-width="2"/>
<path d="M2 26H30" stroke="currentColor" stroke-width="2"/>
<path d="M26 29V26" stroke="currentColor" stroke-width="2"/>
<path d="M19 29V26" stroke="currentColor" stroke-width="2"/>
<path d="M12 29V26" stroke="currentColor" stroke-width="2"/>
<path d="M5 29V26" stroke="currentColor" stroke-width="2"/>
</svg>`;
